{
  "version": "4.2.1",
  "releaseNotes": {
    "title": "What's new in version 4.2.1",
    "items": [
      "Orders1: send Order Confirmation mail for CRT status 10+ from the Cfm & Sync column (customer email from order header).",
      "Item Details V2 (div 100/300): after Save as Draft, offer Sync when the order is already Sync-ready (credit, margin, stock, lines).",
      "Item Details is V2-only in the UI; V1 switch and routes are removed while V1 code remains.",
      "Item lookup: Past sales and Open orders (CRT/PKL/WIP) with polished search, results header, and status badges."
    ]
  }
}
